var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelfsend = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128pt",
    height: "128pt",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00abe6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m59.531 10.52c5.4922 0 9.9609 4.4688 9.9609 9.9609 0 5.4922-4.4688 9.9492-9.9609 9.9492s-9.9609-4.4609-9.9609-9.9492c0-5.4922 4.4688-9.9609 9.9609-9.9609m0-10.52c-11.285 0-20.48 9.1836-20.48 20.48 0 11.285 9.1953 20.469 20.48 20.469s20.48-9.1836 20.48-20.469c0-11.297-9.1953-20.48-20.48-20.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.746 128c-3.0469 0-5.25-3.0625-5.2578-5.957l-0.15234-35.078c0-20.973 18.48-38.027 41.191-38.027 16.641 0 31.969 9.6758 38.152 24.066 1.1484 2.6719-0.085938 5.7656-2.7578 6.9102-2.6406 1.125-5.7539-0.085937-6.9219-2.7656-4.5312-10.582-15.973-17.691-28.469-17.691-16.902 0-30.672 12.328-30.672 27.484l0.14844 35.059c0.007813 2.9062-2.3398 6-5.2422 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.78 109.44h-44.605c-2.9023 0-5.2578-1.7188-5.2578-4.6211s2.3555-5.9844 5.2578-5.9844h45.23c2.9023 0 5.2578 3.082 5.2578 5.9844 0.003906 2.9023-2.3555 4.6211-5.8828 4.6211z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.879 124.86-15.484-16.422c-1.9258-2.0195-1.9258-5.1875 0-7.207l15.484-16.414c1.9805-2.1172 5.3125-2.2305 7.4258-0.21094 2.1133 1.9883 2.207 5.3125 0.21094 7.4258l-12.066 12.801 12.066 12.812c2 2.1055 1.8398 5.375-0.21094 7.4258-2.7188 2.7227-6.4023 0.88281-7.4258-0.21094z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelfsend);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/selfsend.8f27a86563e8c49ec378d057e958b41e.svg";